<script>
import Identity from '@/components/elements/Identity';
import languages from '@/data/languages';
import Modal from '@/components/elements/Modal';
// import { cmsDecode } from '@/tools/cms'
import Snackbar from '@/components/elements/Snackbar';
import { handleRejection } from '@/tools/error-handler';

export default {
    components: { Snackbar, Modal, Identity },
    computed: {
        dataReady() {
            // return this.currentLanguage && this.$store.state.holderConfig && this.$store.state.testProviders.all.length > 0;
            return this.apiConnect;
        },
        displaySnackbar() {
            return this.$store.state.snackbar.visible
        },
        ReturnLanguagenr: function() {
            var languagenr = 0;
            if (this.$route.path === '/InternationalQRCodeEN') {
                languagenr = 1;
            }
            return languagenr;
        }
    },
    data() {
        return {
            routepath: '',
            displayFaq: true,
            displayLanguagePicker: true,
            homeLink: '',
            apiConnect: false
        }
    },
    methods: {
        init() {
            this.fixHeader();
            this.getaccToken();
            this.addLanguages();
            this.setCurrentLanguage();
            this.setTimerToEndSession();
        },
        fixHeader() {
            if ((this.$route.path.includes('InternationalQRCode') === true) || (this.$route.path.includes('InternationalQRCodeEN') === true) || (this.$route.path.includes('faqEN') === true) || (this.$route.path.includes('faqNL') === true) || (this.$route.path.includes('PrivacyStatementEN') === true) || (this.$route.path.includes('PrivacyStatement') === true)) {
                this.$store.commit('languages/setCurrent', this.$store.state.languages.all[1]);
                this.displayFaq = false;
                this.displayLanguagePicker = false;
                this.homeLink = '';
            }
        },
        async getaccToken() {
            this.$axios({
                method: 'post',
                url: this.$config.accToken,
                data: { value: this.$config.applicationid }
            }).then((response) => {
                if (response.data) {
                    switch (response.status) {
                    case 200:
                        this.$store.state.accToken = response.data;
                        this.apiConnect = true;
                        break;
                    default:
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.error.providerInfoNotFound.head'),
                            messageBody: this.$t('message.error.providerInfoNotFound.body'),
                            closeButton: true
                        });
                    }
                }
            }).catch((error) => {
                handleRejection(error);
            })
        },
        addLanguages() {
            this.$store.commit('languages/init', languages);
        },
        setCurrentLanguage() {
            var languagenr = 0;
            const routeNameChunks = window.location.href.split('/');
            if (routeNameChunks.length > 0) {
                if ((this.$route.path === '/InternationalQRCodeEN') || (this.$route.path === '/faqEN') || (this.$route.path.includes('PrivacyStatementEN') === true)) {
                    languagenr = 1;
                }
                const locale = routeNameChunks[3];
                const language = this.$store.getters['languages/getItemByProperty']('locale', locale, true);
                if (language) {
                    this.$store.commit('languages/setCurrent', language);
                } else {
                    this.$store.commit('languages/setCurrent', this.$store.state.languages.all[languagenr]);
                }
            } else {
                this.$store.commit('languages/setCurrent', this.$store.state.languages.all[languagenr]);
            }
            this.$i18n.locale = this.$store.state.languages.current.locale;
            const html = document.documentElement;
            html.setAttribute('lang', this.$store.state.languages.current.locale)
        },
        setTimerToEndSession() {
            const hours = 24;
            const time = hours * 3600000
            setTimeout(() => {
                this.$router.push({ name: 'Home' })
                this.$store.commit('sessionEnded')
                this.$store.commit('modal/set', {
                    messageHead: this.$t('message.info.sessionEnded.head'),
                    messageBody: this.$t('message.info.sessionEnded.body'),
                    closeButton: true
                })
            }, time)
        }
    },
    mounted() {
        this.init();
    },
    updated() {
        if ((this.$route.path.includes('InternationalQRCode') === true) || (this.$route.path.includes('InternationalQRCodeEN') === true) || (this.$route.path.includes('faqEN') === true) || (this.$route.path.includes('faqNL') === true) || (this.$route.path.includes('PrivacyStatementEN') === true) || (this.$route.path.includes('PrivacyStatement') === true)) {
            this.$store.commit('languages/setCurrent', this.$store.state.languages.all[1]);
            this.displayFaq = false;
            this.displayLanguagePicker = false;
            this.homeLink = '';
        }
    }
}
</script>

<template>
    <div
        v-if="dataReady"
        id="app">
        <Identity :displayFaq=this.displayFaq :displayLanguagePicker=this.displayLanguagePicker :homeLink=this.homeLink />
        <router-view/>
        <Snackbar v-if="displaySnackbar"/>
        <Modal/>
    </div>
</template>

<style lang="scss">
@import "@/styles/index";

* {
    box-sizing: border-box;
}
</style>
